import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AggregatorService } from '@mpt-fo/common/core/services/aggregator.service';
import { LocalStorageService } from '@mpt-fo/common/core/services/local-storage.service';
import { ModalOptionsConfig, ModalService } from '@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service';
import { PricingInfoComponent } from '../modals/pricing-info/pricing-info.component';

@Component({
	selector: 'app-pricing',
	templateUrl: './pricing.component.html',
	styleUrls: ['./pricing.component.scss'],
})
export class PricingComponent implements OnInit {
	@Input() IsMobile: boolean = false;
	runningModal;
	@Input() fixedPricing: boolean;
	@Input() AllowedAccess = true;
  @Input() ongoingRequest: boolean = true;
  @Input() pricingPlanData;
	@Input() agentId: number;

	constructor(
    public modal: ModalService, 
    private router: Router,
		private aggregatorService: AggregatorService,
		private localStorage: LocalStorageService,
  ) {
      
    }

	ngOnInit(): void {

  }

	createModalConfig() {
		const config = new ModalOptionsConfig();
		config.className = 'moniepoint-dialog';
		config.nzMaskClosable = true;
		config.nzComponentParams.data = {
			pricingData: this.pricingPlanData,
		};
		return config;
	}

	launchModal(component: any) {
		const config = this.createModalConfig();
		this.runningModal = this.modal.createModal(component, config);
	}

	openPricingInfo() {
		this.launchModal(PricingInfoComponent);
	}

	requestFixedPricing() {
    if(this.pricingPlanData.hasPendingRequest){
      this.aggregatorService.setPricingPlanRequestData(this.pricingPlanData);
      this.localStorage.save('priceConsession', JSON.stringify(this.pricingPlanData));
    }else{
      this.aggregatorService.setPricingPlanRequestData(null);
      this.localStorage.deleteValue('priceConsession');
    }
		this.router.navigateByUrl(`main-app/aggregator/agents/user/pricing-request/${this.agentId}`);
	}
}
